import React, { useMemo } from "react";

import { ICurrentUserContextUserFragment } from "./CurrentUserContext.generated";

export interface ICurrentUserContext {
    currentUser: ICurrentUserContextUserFragment | undefined;
}

export const CurrentUserContext = React.createContext<ICurrentUserContext>({ currentUser: undefined });

interface IProps {
    currentUser: ICurrentUserContextUserFragment | undefined;
}

export const CurrentUserContextProvider: React.FC<React.PropsWithChildren<IProps>> = ({ currentUser, children }) => {
    const contextValue = useMemo((): ICurrentUserContext => ({ currentUser }), [currentUser]);

    return <CurrentUserContext.Provider value={contextValue}>{children}</CurrentUserContext.Provider>;
};
